<ng-select
  [items]="shippingFeePlan$ | async"
  [formControl]="formControl"
  appendTo="body"
  bindLabel="name"
  [addTag]="false"
  [multiple]="false"
  [hideSelected]="true"
  [trackByFn]="trackByFn"
  [minTermLength]="0"
  [loading]="isLoading"
  [typeahead]="input$"
>
  <ng-template ng-label-tmp let-item="item" let-clear="clear">
    {{ item.name }}
  </ng-template>
  <ng-template ng-option-tmp let-item="item">
    {{ item.name }}
  </ng-template>
</ng-select>
